<template>
  <aside>
    <section class="box hero is-white">
      <div class="hero-head">
        <div class="level-right">
          <button class="icon button is-white" @click="close">
            <i class="mdi mdi-close mdi-24px"></i>
          </button>
        </div>
        <br />
        <slot name="head"></slot>
      </div>
      <div class="hero-body">    
        <slot name="body"></slot>
      </div>
      <div class="hero-foot">
        <slot name="foot"></slot>
      </div>
    </section>   
  </aside>
</template>
<script>
export default {
  name: "Sidebar",
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>
